import { Box, Typography } from "@mui/material";
import React from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ButtonComponent from "../../components/Elements/Button/Button";
import "./JobCart.css";
import { Padding } from "@mui/icons-material";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import { Link, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";


const JobCart = () => {
  const { jobId } = useParams();
  console.log("Job ID from URL:", jobId);
  const location = useLocation();
  const { job } = location.state || {};
  console.log("Received Job:", job);
  if (!job) {
    return <Typography>Job not found. Please go back.</Typography>;
  }
  return (
    <>
      <Box
        className="opening-main-job"
        flexDirection={"column"}
        sx={{ heigh: "220px !important" }}
      >
        <Typography className="opening-heading" textTransform={"capitalize"}>
        {job.jobTitle}
        </Typography>
        <Box display={"flex"} gap={1} mt={1}>
          <LocationOnIcon fontSize="small" sx={{ color: "white" }} />
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ color: "white" }}
            textTransform={"capitalize"}
          >
            {job.location}
            </Typography>
        </Box>
      </Box>
      <Box padding={"80px"}>
        <Typography className="companyName" textTransform={"capitalize"} >{job.companyName}</Typography>
        <Typography className="Cryptographic" textTransform={"capitalize"}>
        {job.jobTitle}
        </Typography>
        <Box display={"flex"} mt={2} mb={2} gap={2}>
          <ButtonComponent type={"button"} className={"jobbutton"} 
          >
            <Icon
              src={Images.fulltime}
              alt={""}
              style={{ marginRight: "8px", marginTop: "-5px" }}
              
            ></Icon>{" "}
            {job.employmentType}
            </ButtonComponent>
          <ButtonComponent type={"button"} className={"jobbutton"}>
            <Icon
              src={Images.Remote}
              alt={""}
              style={{ marginRight: "8px", marginTop: "-5px" }}
            ></Icon>
            {job.workMode}
            </ButtonComponent>
        </Box>
        <Typography className="Overview">Job Overview</Typography>
        <Typography className="Responsibilities">{job.message}</Typography>
        <Link  to={`/opening/${job.jobId}/apply`} style={{ textDecoration: "none" }} state={{job}}>

        <ButtonComponent
          type="button"
          className="Apply"
          style={{
            background: "#741374",
            color: "white",
            margin: "15px",
            width: "150px !important",
          }}
        >
          Apply Now{" "}
        </ButtonComponent>
        </Link>

        {/* <ButtonComponent
          type="button"
          className="Apply"
          style={{ background: "#741374", color: "white", margin: "15px" }}
        >
          Share{" "}
        </ButtonComponent>{" "} */}
      </Box>
    </>
  );
};
export default JobCart;
